import React from 'react';
import './FooterStyle.css';

function Footer() {
    return (
        <footer>
            <p>Noemí Armengod - 2025</p>
        </footer>
    )
}

export default Footer;